import React from 'react';

import { useCapability } from '@vimeo/core/hooks/use-capability';
import { translate } from '@vimeo/i18n-runtime';
import { User } from '@vimeo/viewer';

import ContentModal from '../components/ContentModal';
import { FileDownload } from '../types';
import { DownloadPanel } from './DownloadPanel';

type Props = {
  allowDownloads: boolean;
  clipId: number;
  curUser?: User;
  downloadConfig: FileDownload[];
  ownerId: number;
  isOwnerOrAdmin: boolean;
  onClose: VoidFunction;
  fetchColdSourceFile: (url?: string) => void;
  modalOpen: boolean;
  isDefrosting: boolean;
};

export function ClipDownloadModal(props: Props) {
  const { allowDownloads, clipId, downloadConfig, onClose, fetchColdSourceFile, modalOpen } = props;

  const { capabilities } = useCapability(['hasPaid']);
  if (!capabilities) {
    return null;
  }

  const downloadHeaderText = translate('Download');

  return (
    <ContentModal modalHeader={downloadHeaderText} open={modalOpen} onClose={onClose}>
      <DownloadPanel
        {...props}
        allowDownloads={allowDownloads}
        clipId={clipId}
        downloadConfig={downloadConfig}
        fetchColdSourceFile={fetchColdSourceFile}
      />
    </ContentModal>
  );
}
